/**
 * Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
 * analytics events keep the historical "owner note" name on purpose — do not rename them.
 *
 * "All details" is one switch for the whole page (Guillaume, 2026-09-09): opening it on one
 * card opens the comparison rows on every card, so the reader scans the grid in one state
 * instead of clicking per card. Module-level like `bus.ts` — the cards share no ancestor
 * that owns them. Resets with the page (no storage: a fresh visit starts at a glance).
 */
import { useEffect, useState } from 'react'

let openAll = false
const listeners = new Set<(open: boolean) => void>()

export function setAllDetailsOpen(open: boolean): void {
  if (open === openAll) {
    return
  }
  openAll = open
  listeners.forEach(fn => fn(open))
}

/** The shared flag and its setter — every subscriber re-renders on a change. */
export function useAllDetailsOpen(): [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(openAll)
  useEffect(() => {
    setOpen(openAll)
    listeners.add(setOpen)
    return () => {
      listeners.delete(setOpen)
    }
  }, [])
  return [open, setAllDetailsOpen]
}
